module.exports = __webpack_public_path__ + "assets/img/gongren.dc00caf5.png";